var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVantioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 40",
    fill: "none",
    role: "img",
    "aria-label": "Vantio",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4 L14 36 L10 36 L2 12 Z",
    fill: "#FF7A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12 L14 36 L28 36 L10 4 Z",
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 27,
    fontFamily: "ui-sans-serif, system-ui, -apple-system, Segoe UI, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#0f172a"
  }, "Vantio")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVantioLogo);
export default __webpack_public_path__ + "static/media/vantio-logo.970afa0bd2aa67ea0492c7b655f78aaf.svg";
export { ForwardRef as ReactComponent };